import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../store";
import { clearUser, setUser } from "../slices/userSlice";
import { revalidateClientSso } from "../api/auth";
import {
  CLIENT_SSO_ENTRY_PATH,
  CLIENT_SSO_REVALIDATE_INTERVAL_MS,
  isClientSsoUser,
  markClientSsoSessionEnded,
} from "../../constants/clientSso";

export const useClientSsoRevalidate = () => {
  const dispatch = useDispatch<AppDispatch>();
  const group = useSelector((state: RootState) => state.user.userInfo?.group);

  useEffect(() => {
    if (!isClientSsoUser(group)) {
      return;
    }

    const timer = window.setInterval(async () => {
      try {
        const response = await revalidateClientSso();
        const user = response.data?.data?.user;
        if (user) {
          dispatch(setUser(user));
        }
      } catch {
        dispatch(clearUser());
        markClientSsoSessionEnded(
          "Your session expired. Please return to the client platform and open Generative again."
        );
        window.location.assign(CLIENT_SSO_ENTRY_PATH);
      }
    }, CLIENT_SSO_REVALIDATE_INTERVAL_MS);

    return () => window.clearInterval(timer);
  }, [dispatch, group]);
};
